module.exports = __webpack_public_path__ + "static/media/usdt.d3378690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/usdt.svg
// module id = 262
// module chunks = 7